/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StringPair,
    StringPairFromJSON,
    StringPairFromJSONTyped,
    StringPairToJSON,
} from './';

/**
 * 
 * @export
 * @interface StringMap
 */
export interface StringMap {
    /**
     * 
     * @type {Array<StringPair>}
     * @memberof StringMap
     */
    dict: Array<StringPair>;
}

export function StringMapFromJSON(json: any): StringMap {
    return StringMapFromJSONTyped(json, false);
}

export function StringMapFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringMap {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dict': ((json['dict'] as Array<any>).map(StringPairFromJSON)),
    };
}

export function StringMapToJSON(value?: StringMap | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dict': ((value.dict as Array<any>).map(StringPairToJSON)),
    };
}


